/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import moment from 'moment'
import { Dispatch } from 'redux'
import { deletePage,
  saveCompanyEmployees,
  saveCompanyInfo,
  savePage } from '../../api/api'
import { Company, MeetingPage, MeetingPageCopy } from '../../types/plann3r'
import { REQUEST_SETTINGS } from '../settings/actions'

export const SAVING_PAGES = 'SAVING_PAGES'
export const savingPages = () => {
  return {
    type: SAVING_PAGES,
  }
}

export const SAVED_PAGES = 'SAVED_PAGES'
export const savedPages = () => {
  return {
    type: SAVED_PAGES,
  }
}

export const SET_ACTIVE_COMPANY = 'SET_ACTIVE_COMPANY'
export const setActiveCompany = (company_id: number) => {
  return {
    type: SET_ACTIVE_COMPANY,
    active_company: company_id,
  }
}

export const SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE'
export const setActivePage = (page_id: number) => {
  return {
    type: SET_ACTIVE_PAGE,
    active_page: page_id,
  }
}

export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB'
export const setActiveTab = (tab: string | null) => {
  return {
    type: SET_ACTIVE_TAB,
    active_tab: tab,
  }
}
export const SET_LATEST_PAGE = 'SET_LATEST_PAGE'
export const setLatestPage = (page: string) => {
  return {
    type: SET_LATEST_PAGE,
    page: page,
  }
}

export const REQUEST_COMPANIES = 'REQUEST_COMPANIES'
export const requestCompanies = () => {
  return {
    type: REQUEST_COMPANIES,
  }
}

export const RECEIVE_COMPANIES = 'RECEIVE_COMPANIES'
export const receiveCompanies = (companies: Company[]) => {
  return {
    type: RECEIVE_COMPANIES,
    companies,
  }
}

export const EDITOR_SAVE = 'EDITOR_SAVE'
export const editorSave = () => {
  return {
    type: EDITOR_SAVE,
  }
}

export const EDITOR_UPDATE_LOGO = 'EDITOR_UPDATE_LOGO'
export const editorUpdateLogo = (logo: string) => {
  return {
    type: EDITOR_UPDATE_LOGO,
    logo,
  }
}

export const EDITOR_UPDATE_LABEL = 'EDITOR_UPDATE_LABEL'
export const editorUpdateLabel = (id: number, label: string) => {
  return {
    type: EDITOR_UPDATE_LABEL,
    id,
    label,
  }
}

export const EDITOR_UPDATE_COPY = 'EDITOR_UPDATE_COPY'
export const editorUpdateCopy = (copy: MeetingPageCopy) => {
  return {
    type: EDITOR_UPDATE_COPY,
    copy,
  }
}

export const EDITOR_UPDATE_DISPLAY_NAME = 'EDITOR_UPDATE_DISPLAY_NAME'
export const editorUpdateDisplayName = (display_name: string) => {
  return {
    type: EDITOR_UPDATE_DISPLAY_NAME,
    display_name,
  }
}

export const EDITOR_UPDATE_PRIMARY_COLOR = 'EDITOR_UPDATE_PRIMARY_COLOR'
export const editorUpdatePrimaryColor = (color: string) => {
  return {
    type: EDITOR_UPDATE_PRIMARY_COLOR,
    color,
  }
}

export const EDITOR_UPDATE_SECONDARY_COLOR = 'EDITOR_UPDATE_SECONDARY_COLOR'
export const editorUpdateSecondaryColor = (color: string) => {
  return {
    type: EDITOR_UPDATE_SECONDARY_COLOR,
    color,
  }
}

export const EDITOR_UPDATE_DURATION_LABEL = 'EDITOR_UPDATE_DURATION_LABEL'
export const editorUpdateDurationLabel = (id: number, label: string) => {
  return {
    type: EDITOR_UPDATE_DURATION_LABEL,
    id,
    label,
  }
}

export const EDITOR_UPDATE_DURATION = 'EDITOR_UPDATE_DURATION'
export const editorUpdateDuration = (id: number, duration: number) => {
  return {
    type: EDITOR_UPDATE_DURATION,
    id,
    duration,
  }
}

export const EDITOR_ADD_DURATION = 'EDITOR_ADD_DURATION'
export const editorAddDuration = () => {
  return {
    type: EDITOR_ADD_DURATION,
  }
}

export const EDITOR_DELETE_DURATION = 'EDITOR_DELETE_DURATION'
export const editorDeleteDuration = (duration: number) => {
  return {
    type: EDITOR_DELETE_DURATION,
    id: duration,
  }
}

export const EDITOR_UPDATE_PLACEHOLDER = 'EDITOR_UPDATE_PLACEHOLDER'
export const editorUpdatePlaceholder = (id: number, placeholder: string) => {
  return {
    type: EDITOR_UPDATE_PLACEHOLDER,
    id,
    placeholder,
  }
}

export const EDITOR_UPDATE_LOCATION = 'EDITOR_UPDATE_LOCATION'
export const editorUpdateLocation = (location: any) => {
  for (const key in location) {
    return {
      type: EDITOR_UPDATE_LOCATION,
      location: location[key],
      id: parseInt(key, 10),
    }
  }
}

export const EDITOR_UPDATE_COPY_VIDEOCALL = 'EDITOR_UPDATE_COPY_VIDEOCALL'
export const editorUpdateCopyVideocall = (videocall: any) => {
  for (const key in videocall) {
    return {
      type: EDITOR_UPDATE_COPY_VIDEOCALL,
      videocall: videocall[key],
      id: parseInt(key, 10),
    }
  }
}

export const EDITOR_UPDATE_COPY_PHYSICAL = 'EDITOR_UPDATE_COPY_PHYSICAL'
export const editorUpdateCopyPhysical = (physical: any) => {
  for (const key in physical) {
    return {
      type: EDITOR_UPDATE_COPY_PHYSICAL,
      physical: physical[key],
      id: parseInt(key, 10),
    }
  }
}

export const EDITOR_ADD_FIELD = 'EDITOR_ADD_FIELD'
export const editorAddField = (form: any) => {
  return {
    type: EDITOR_ADD_FIELD,
    form,
  }
}

export const EDITOR_TOGGLE_REQUIRED = 'EDITOR_TOGGLE_REQUIRED'
export const editorToggleRequired = (id: number) => {
  return {
    type: EDITOR_TOGGLE_REQUIRED,
    id,
  }
}

export const EDITOR_REMOVE_FIELD = 'EDITOR_REMOVE_FIELD'
export const editorRemoveField = (id: number) => {
  return {
    type: EDITOR_REMOVE_FIELD,
    id,
  }
}

export const PAGE_UPDATE_NAME = 'PAGE_UPDATE_NAME'
export const pageUpdateName = (name: string) => {
  return {
    type: PAGE_UPDATE_NAME,
    name,
  }
}

export const PAGE_UPDATE_TIMEZONE = 'PAGE_UPDATE_TIMEZONE'
export const pageUpdateTimezone = (tz: string) => {
  return {
    type: PAGE_UPDATE_TIMEZONE,
    tz,
  }
}

export const PAGE_UPDATE_PARTICIPANTS = 'PAGE_UPDATE_PARTICIPANTS'
export const pageUpdateParticipants = (participants: number) => {
  return {
    type: PAGE_UPDATE_PARTICIPANTS,
    participants,
  }
}

export const PAGE_ADD_EMPLOYEE = 'PAGE_ADD_EMPLOYEE'
export const pageAddEmployee = (employee: number) => {
  return {
    type: PAGE_ADD_EMPLOYEE,
    employee,
  }
}

export const PAGE_SET_REQUIRED_EMPLOYEE = 'PAGE_SET_REQUIRED_EMPLOYEE'
export const setRequiredEmployee = (employee: number, required: boolean) => {
  return {
    type: PAGE_SET_REQUIRED_EMPLOYEE,
    employee,
    required,
  }
}

export const PAGE_DELETE_EMPLOYEE = 'PAGE_DELETE_EMPLOYEE'
export const pageDeleteEmployee = (employee: number) => {
  return {
    type: PAGE_DELETE_EMPLOYEE,
    employee,
  }
}

export const COMPANY_INFO_UPDATE_NAME = 'COMPANY_INFO_UPDATE_NAME'
export const companyInfoUpdateName = (name: string) => {
  return {
    type: COMPANY_INFO_UPDATE_NAME,
    name,
  }
}

export const COMPANY_ADD_PAGE = 'COMPANY_ADD_PAGE'
export const companyAddPage = (creator: number) => {
  return {
    type: COMPANY_ADD_PAGE,
    creator,
  }
}

export const COMPANY_ADD_EMPLOYEE = 'COMPANY_ADD_EMPLOYEE'
export const companyAddEmployee = (employee: string) => {
  return {
    type: COMPANY_ADD_EMPLOYEE,
    employee,
  }
}

export const COMPANY_DELETE_EMPLOYEE = 'COMPANY_DELETE_EMPLOYEE'
export const companyDeleteEmployee = (id: number) => {
  return {
    type: COMPANY_DELETE_EMPLOYEE,
    id,
  }
}

export const COMPANY_MAKE_ADMIN = 'COMPANY_MAKE_ADMIN'
export const companyMakeAdmin = (id: number) => {
  return {
    type: COMPANY_MAKE_ADMIN,
    id,
  }
}

export const COMPANY_SET_AVATAR = 'COMPANY_SET_AVATAR'
export const companySetAvatar = (avatar: string) => {
  return {
    type: COMPANY_SET_AVATAR,
    avatar,
  }
}

export const PAGE_SET_TEMPORARY_START = 'PAGE_SET_TEMPORARY_START'
export const pageSetTemporaryStart = (date: string) => {
  return {
    type: PAGE_SET_TEMPORARY_START,
    date,
  }
}

export const PAGE_SET_TEMPORARY_END = 'PAGE_SET_TEMPORARY_END'
export const pageSetTemporaryEnd = (date: string) => {
  return {
    type: PAGE_SET_TEMPORARY_END,
    date,
  }
}

export const PAGE_TOGGLE_AUTO_ACCEPT = 'PAGE_TOGGLE_AUTO_ACCEPT'
export const pageToggleAutoAccept = () => {
  return {
    type: PAGE_TOGGLE_AUTO_ACCEPT,
  }
}

export const PAGE_TOGGLE_ONE_MOMENT = 'PAGE_TOGGLE_ONE_MOMENT'
export const pageToggleOneMoment = () => {
  return {
    type: PAGE_TOGGLE_ONE_MOMENT,
  }
}

export const PAGE_SET_PREFERRED_LANGUAGE = 'PAGE_SET_PREFERRED_LANGUAGE'
export const pageSetPreferredLanguage = (language: string) => {
  return {
    type: PAGE_SET_PREFERRED_LANGUAGE,
    language,
  }
}

export const PAGE_SET_PREFERRED_TIMES = 'PAGE_SET_PREFERRED_TIMES'
export const pageSetPreferredTimes = (preferred_times: Range[]) => {
  return {
    type: PAGE_SET_PREFERRED_TIMES,
    preferred_times,
  }
}

export const PAGE_TOGGLE_SEQUENTIAL = 'PAGE_TOGGLE_SEQUENTIAL'
export const pageToggleSequential = () => {
  return {
    type: PAGE_TOGGLE_SEQUENTIAL,
  }
}

export const PAGE_SET_BUFFER = 'PAGE_SET_BUFFER'
export const pageSetBuffer = (buffer: number) => {
  return {
    type: PAGE_SET_BUFFER,
    buffer: buffer,
  }
}

export const PAGE_SET_FASTEST_POSSIBLE = 'PAGE_SET_FASTEST_POSSIBLE'
export const pageSetFastestPossible = (fastest_possible: number) => {
  return {
    type: PAGE_SET_FASTEST_POSSIBLE,
    fastest_possible: fastest_possible,
  }
}

export const PAGE_TOGGLE_IGNORE_CALENDARS = 'PAGE_TOGGLE_IGNORE_CALENDARS'
export const pageToggleIgnoreCalendars = () => {
  return {
    type: PAGE_TOGGLE_IGNORE_CALENDARS,
  }
}

export const PAGE_TOGGLE_MY_OFFICE = 'PAGE_TOGGLE_MY_OFFICE'
export const pageToggleMyOffice = () => {
  return {
    type: PAGE_TOGGLE_MY_OFFICE,
  }
}

export const PAGE_TOGGLE_CALL = 'PAGE_TOGGLE_CALL'
export const pageToggleCall = () => {
  return {
    type: PAGE_TOGGLE_CALL,
  }
}

export const PAGE_TOGGLE_THEIR_OFFICE = 'PAGE_TOGGLE_THEIR_OFFICE'
export const pageToggleTheirOffice = () => {
  return {
    type: PAGE_TOGGLE_THEIR_OFFICE,
  }
}

export const PAGE_ADD_OTHER_OFFICE = 'PAGE_ADD_OTHER_OFFICE'
export const pageAddOtherOffice = () => {
  return {
    type: PAGE_ADD_OTHER_OFFICE,
  }
}

export const PAGE_CHANGE_OFFICE = 'PAGE_CHANGE_OFFICE'
export const pageChangeOffice = (index: number, newAddress: string) => {
  return {
    type: PAGE_CHANGE_OFFICE,
    index,
    newAddress,
  }
}

export const PAGE_REMOVE_OFFICE = 'PAGE_REMOVE_OFFICE'
export const pageRemoveOffice = (index: number) => {
  return {
    type: PAGE_REMOVE_OFFICE,
    index,
  }
}

export const PAGE_ADD_CALL_OPTION = 'PAGE_ADD_CALL_OPTION'
export const pageAddCallOption = () => {
  return {
    type: PAGE_ADD_CALL_OPTION,
  }
}

export const PAGE_CHANGE_CALL_OPTION_TYPE = 'PAGE_CHANGE_CALL_OPTION_TYPE'
export const pageChangeCallOptionType = (index: number, newType: string) => {
  return {
    type: PAGE_CHANGE_CALL_OPTION_TYPE,
    index,
    newType,
  }
}

export const PAGE_CHANGE_CALL_OPTION_VALUE = 'PAGE_CHANGE_CALL_OPTION_VALUE'
export const pageChangeCallOptionValue = (index: number, newValue: string) => {
  return {
    type: PAGE_CHANGE_CALL_OPTION_VALUE,
    index,
    newValue,
  }
}

export const PAGE_REMOVE_CALL_OPTION = 'PAGE_REMOVE_CALL_OPTION'
export const pageRemoveCallOption = (index: number) => {
  return {
    type: PAGE_REMOVE_CALL_OPTION,
    index,
  }
}

export const PAGE_UPDATE_PIXEL = 'PAGE_UPDATE_PIXEL'
export const pageUpdatePixel = (pixel: string) => {
  return {
    type: PAGE_UPDATE_PIXEL,
    pixel,
  }
}

export const PAGE_UPDATE_GA = 'PAGE_UPDATE_GA'
export const pageUpdateGA = (ga: string) => {
  return {
    type: PAGE_UPDATE_GA,
    ga,
  }
}

export const PAGE_UPDATE_CSS = 'PAGE_UPDATE_CSS'
export const pageUpdateCSS = (css: string) => {
  return {
    type: PAGE_UPDATE_CSS,
    css,
  }
}

export const PAGE_UPDATE_JS = 'PAGE_UPDATE_JS'
export const pageUpdateJS = (js: string) => {
  return {
    type: PAGE_UPDATE_JS,
    js,
  }
}

export const SAVE_COMPANIES = 'SAVE_COMPANIES'
export const saveCompanies = (companies: Company[]) => {
  return (dispatch: Dispatch) => {
    dispatch({ type: SAVING_PAGES })
    save(companies, dispatch)
  }
}

const validatePage = (page: MeetingPage) => {
  if (!page || page.name === '' || page.name === null)
    return 'Page name missing.'

  // TODO: VALIDATE LOCATIONS

  /*const durations = page.fields.find((field) => field.type === 'duration')
    ?.durations*/

  // TODO: VALIDATE DURATIONS

  return null
}

const save = (companies: Company[], dispatch: Dispatch) => {
  let company, pages, page
  let isNew = false

  for (let i = 0; i < companies.length; i++) {
    company = companies[i]
    if (company.not_saved) {
      // SAVE INFO
      saveCompanyInfo({ company_id: company.id, info: JSON.stringify(company) })

      // SAVE EMPLOYEES
      saveCompanyEmployees({ companyId: company.id, employees: JSON.stringify(company.employees) })
    }

    // CHECK IF PAGES OF COMPANY WERE CHANGED
    pages = company.pages
    for (let j = 0; j < pages.length; j++) {
      page = pages[j]

      if (page.not_saved) {
        if (page.start) {
          page.start = moment(page.start)
            .startOf('day')
            .format('YYYY-MM-DDTHH:mm:ssZZ')
        }
        if (page.end) {
          page.end = moment(page.end)
            .startOf('day')
            .format('YYYY-MM-DDTHH:mm:ssZZ')
        }

        const message = validatePage(page)
        if (message !== null) {
          alert(message)
          continue
        }

        if (page.new) {
          isNew = true
        }
        // SAVE PAGE
        // eslint-disable-next-line
        savePage({ pageId: page.id, companyId: company.id, pageInfo: JSON.stringify(page) })
          .catch(() => {
            window.location.reload()
          })
      }
    }
  }

  if (isNew) {
    dispatch({ type: REQUEST_SETTINGS })
  }

  dispatch(savedPages())
}

export const deleteCompanyPage = (id: number) => {
  return async (dispatch: Dispatch) => {
    const data = {
      pageId: id,
    }
    const response = await deletePage(data)

    if (response.success) {
      dispatch({ type: REQUEST_SETTINGS })
    } else {
      alert('Something went wrong, please try again.')
    }
  }
}

export const CHANGE_ACTION = 'CHANGE_ACTION'
export const changeAction = (
  integration_id: number,
  action_id: number,
  local_action_id: number,
  value: string,
  selected: boolean,
) => {
  return {
    type: CHANGE_ACTION,
    integration_id,
    action_id,
    local_action_id,
    value,
    selected,
  }
}